import { render, staticRenderFns } from "./editAddressModal.vue?vue&type=template&id=57d3f492&"
import script from "./editAddressModal.vue?vue&type=script&lang=js&"
export * from "./editAddressModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports